import React from "react";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import RewardEntryPage from "./pages/Rewards/RewardEntryPage";

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/reward-entry" element={<RewardEntryPage />} />
                <Route path="*" element={<Navigate to="/reward-entry" replace />} />
            </Routes>
        </Router>
    );
};

export default App;
